/**
 * ChannelsHeader
 *
 * Header da aba Canais com:
 * - Resumo: "X canais conectados · Y com alerta"
 * - Filtro toggle "Mostrar só com alerta"
 * - AlertInbox (sininho)
 */

import React, { useMemo } from 'react';
import { IconFilter } from '@tabler/icons-react';
import AlertInbox from '../../alerts/AlertInbox';
import { CHANNEL_REGISTRY } from '../../../channels/registry';

const ChannelsHeader = ({
  agentId,
  filterAlertOnly,
  onToggleFilter,
  onAlertCTA,
}) => {
  // Conta canais ativos via cada plugin's useStatus seria ideal mas exigiria
  // hooks dentro de loop. Para simplicidade do header, calculamos manualmente
  // via flag isAvailable; o resumo preciso fica nos cards.
  const totalAvailable = useMemo(
    () => CHANNEL_REGISTRY.filter((c) => c.isAvailable).length,
    [],
  );

  return (
    <div className="channels-header">
      <div className="channels-header__info">
        <h3 className="channels-header__title">Canais do Agente</h3>
        <p className="channels-header__subtitle">
          Conecte e gerencie os canais de comunicação. {totalAvailable} canal(is) disponível(is).
        </p>
      </div>

      <div className="channels-header__actions">
        <button
          type="button"
          className={`channels-header__filter-btn ${filterAlertOnly ? 'channels-header__filter-btn--active' : ''}`}
          onClick={onToggleFilter}
          title="Mostrar apenas canais com alerta"
        >
          <IconFilter size={14} />
          {filterAlertOnly ? 'Mostrando só alertas' : 'Filtrar'}
        </button>

        <AlertInbox onAction={onAlertCTA} />
      </div>
    </div>
  );
};

export default ChannelsHeader;
